"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectCurrentTrackIsCached = exports.selectCurrentAvailableMediafileIds = exports.selectLastDefaultPlaylistRotationId = exports.selectPlaylistMediafileIds = exports.selectPlaylistItemsWithMediafilesWithLimit = exports.selectPlaylistItemsWithMediafiles = exports.selectCurrentPlaylistStream = exports.selectPlaylistLength = exports.selectPlaylistItems = exports.selectSafeSwitchZone = exports.selectPlaylistItemWithMediafile = exports.selectNextPlaylistItemsWithMediafiles = exports.selectCurrentPlaylistItemWithMediafile = exports.selectCurrentPlaylistItem = void 0;
var Mediafiles_1 = __importDefault(require("../services/Mediafiles"));
var _kernel_store_types_1 = require("../types");
var mediafiles_1 = require("./mediafiles");
function selectCurrentPlaylistItem(state) {
    var _a, _b;
    var playlist = selectPlaylist(state);
    var items = (_a = playlist === null || playlist === void 0 ? void 0 : playlist.items) !== null && _a !== void 0 ? _a : [];
    return (_b = items[0]) !== null && _b !== void 0 ? _b : null;
}
exports.selectCurrentPlaylistItem = selectCurrentPlaylistItem;
function selectCurrentPlaylistItemWithMediafile(state) {
    var _a;
    var item = selectCurrentPlaylistItem(state);
    if (!item) {
        return null;
    }
    return __assign(__assign({}, item), { mediafile: (_a = state.mediafiles) === null || _a === void 0 ? void 0 : _a[item.mediafileId] });
}
exports.selectCurrentPlaylistItemWithMediafile = selectCurrentPlaylistItemWithMediafile;
function selectNextPlaylistItemsWithMediafiles(state, limit) {
    var _a;
    var playlist = selectPlaylist(state);
    var items = (_a = playlist === null || playlist === void 0 ? void 0 : playlist.items) !== null && _a !== void 0 ? _a : [];
    return items.slice(0, limit);
}
exports.selectNextPlaylistItemsWithMediafiles = selectNextPlaylistItemsWithMediafiles;
function selectPlaylistItemWithMediafile(state, rotationId) {
    var _a, _b;
    var rotation = (_a = state.playlist.items) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item.rotationId === rotationId; });
    if (!rotation) {
        return null;
    }
    return __assign(__assign({}, rotation), { mediafile: (_b = state.mediafiles) === null || _b === void 0 ? void 0 : _b[rotation.mediafileId] });
}
exports.selectPlaylistItemWithMediafile = selectPlaylistItemWithMediafile;
function selectPlaylist(state) {
    var _a;
    return (_a = state.playlist) !== null && _a !== void 0 ? _a : null;
}
function selectSafeSwitchZone(state) {
    return state.playlist.safeSwitchZone;
}
exports.selectSafeSwitchZone = selectSafeSwitchZone;
function selectPlaylistItems(state) {
    var _a, _b;
    return (_b = (_a = selectPlaylist(state)) === null || _a === void 0 ? void 0 : _a.items) !== null && _b !== void 0 ? _b : [];
}
exports.selectPlaylistItems = selectPlaylistItems;
function selectPlaylistLength(state) {
    var _a, _b, _c;
    return (_c = (_b = (_a = selectPlaylist(state)) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0;
}
exports.selectPlaylistLength = selectPlaylistLength;
function selectCurrentPlaylistStream(playlist) {
    function mostFrequent(arr, n) {
        var hash = new Map();
        for (var i = 0; i < n; i++) {
            if (hash.has(arr[i])) {
                hash.set(arr[i], hash.get(arr[i]) + 1);
            }
            else {
                hash.set(arr[i], 1);
            }
        }
        var max_count = 0, res = -1;
        hash.forEach(function (value, key) {
            if (max_count < value) {
                res = key;
                max_count = value;
            }
        });
        return res;
    }
    var streamIds = playlist.map(function (item) { return item.streamId; }).filter(function (streamId) { return streamId; });
    return streamIds.length > 0 ? mostFrequent(streamIds, streamIds.length) : null;
}
exports.selectCurrentPlaylistStream = selectCurrentPlaylistStream;
function selectPlaylistItemsWithMediafiles(state) {
    return selectPlaylistItems(state).map(function (item) {
        var _a;
        return (__assign(__assign({}, item), { mediafile: (_a = state.mediafiles) === null || _a === void 0 ? void 0 : _a[item.mediafileId] }));
    });
}
exports.selectPlaylistItemsWithMediafiles = selectPlaylistItemsWithMediafiles;
function selectPlaylistItemsWithMediafilesWithLimit(state, limit) {
    var playListItems = selectPlaylistItemsWithMediafiles(state);
    return limit ? playListItems.slice(0, limit) : playListItems;
}
exports.selectPlaylistItemsWithMediafilesWithLimit = selectPlaylistItemsWithMediafilesWithLimit;
function selectPlaylistMediafileIds(state) {
    return selectPlaylistItems(state).map(function (item) { return item.mediafileId; });
}
exports.selectPlaylistMediafileIds = selectPlaylistMediafileIds;
function selectLastDefaultPlaylistRotationId(state) {
    var rotationIds = selectPlaylistItems(state).map(function (item) { return item.rotationId; });
    return rotationIds.length > 0 ? Math.max.apply(Math, __spreadArray([], __read(rotationIds), false)) : null;
}
exports.selectLastDefaultPlaylistRotationId = selectLastDefaultPlaylistRotationId;
function selectCurrentAvailableMediafileIds(state, downloadingEnabled) {
    return Object.values(state.mediafiles)
        .filter(function (mediafile) {
        return downloadingEnabled
            ? Mediafiles_1.default.getCacheStateFromMediafile(mediafile) === _kernel_store_types_1.EMediafileCacheState.CACHE
            : _kernel_store_types_1.EMediafileCacheState.CACHE;
    })
        .map(function (mediafile) { return mediafile.id; });
}
exports.selectCurrentAvailableMediafileIds = selectCurrentAvailableMediafileIds;
function selectCurrentTrackIsCached(state) {
    var _a, _b;
    var playlist = selectPlaylist(state);
    var items = (_a = playlist === null || playlist === void 0 ? void 0 : playlist.items) !== null && _a !== void 0 ? _a : [];
    var nextTrackId = (_b = items[0]) === null || _b === void 0 ? void 0 : _b.mediafileId;
    var mediafile = (0, mediafiles_1.selectMediafile)(nextTrackId, state);
    if (!mediafile) {
        return false;
    }
    return Mediafiles_1.default.getCacheStateFromMediafile(mediafile) === _kernel_store_types_1.EMediafileCacheState.CACHE;
}
exports.selectCurrentTrackIsCached = selectCurrentTrackIsCached;
//# sourceMappingURL=playlist.js.map